var generateLinearEasing = function generateLinearEasing(easing, duration) // as milliseconds
{
  var resolution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var points = "";
  var numPoints = Math.max(Math.round(duration / resolution), 2);

  for (var i = 0; i < numPoints; i++) {
    points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
  }

  return "linear(".concat(points.substring(0, points.length - 2), ")");
};

export { generateLinearEasing };